import { DriftmeddelandeResponse } from '@/features/content/types/pages';
import apiClient from '@/lib/apiClient';

const driftmeddelandenQueryKey = ['driftmeddelanden'];
const fetchDriftmeddelanden: () => Promise<DriftmeddelandeResponse[]> = async () => {
  const driftmeddelandeResponse = await apiClient.fetch(location.href, `/api/driftmeddelanden`);

  return driftmeddelandeResponse.json();
};

export const driftmeddelandenQueryOptions = {
  queryKey: driftmeddelandenQueryKey,
  queryFn: () => fetchDriftmeddelanden(),
  staleTime: 1000 * 60 * 10,
  refetchInterval: 1000 * 60 * 10,
};
